import { render, staticRenderFns } from "./DriversModal.vue?vue&type=template&id=6aef892b"
import script from "./DriversModal.vue?vue&type=script&lang=ts"
export * from "./DriversModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports